import { createFileRoute } from '@tanstack/react-router'
import { PepRouteComponent } from '@/components/pep/PepRouteComponent'

export const Route = createFileRoute('/$location/services/prep/')({
	head: ({ params: { location } }) => ({
		meta:
			location === 'Fort-Lauderdale'
				? [
						{ title: 'Understanding PrEP for HIV Prevention | PrEP with Truvada and Descovy | Wellview Care | Fort Lauderdale' },
						{
							name: 'description',
							content:
								"Explore the benefits of Pre-Exposure Prophylaxis (PrEP) for HIV prevention with Truvada and Descovy at Wellview Care in Fort Lauderdale. Learn how PrEP works, its effectiveness, and the expert guidance you'll receive from our healthcare professionals.",
						},
						{
							name: 'keywords',
							content: 'PrEP, Truvada, Descovy, HIV Prevention, Wellview Care Fort Lauderdale',
						},
					]
				: location === 'Riviera-Beach'
					? [
							{
								title: 'Understanding PrEP for HIV Prevention | PrEP with Truvada and Descovy | Wellview Care | Riviera Beach',
							},
							{
								name: 'description',
								content:
									"Explore the benefits of Pre-Exposure Prophylaxis (PrEP) for HIV prevention with Truvada and Descovy at Wellview Care in Riviera Beach. Learn how PrEP works, its effectiveness, and the expert guidance you'll receive from our healthcare professionals.",
							},
							{
								name: 'keywords',
								content: 'PrEP, Truvada, Descovy, HIV Prevention, Wellview Care Riviera Beach',
							},
						]
					: location === 'Jacksonville'
						? [
								{
									title: 'Understanding PrEP for HIV Prevention | PrEP with Truvada and Descovy | Wellview Care | Jacksonville',
								},
								{
									name: 'description',
									content:
										"Explore the benefits of Pre-Exposure Prophylaxis (PrEP) for HIV prevention with Truvada and Descovy at Wellview Care in Jacksonville. Learn how PrEP works, its effectiveness, and the expert guidance you'll receive from our healthcare professionals.",
								},
								{
									name: 'keywords',
									content: 'PrEP, Truvada, Descovy, HIV Prevention, Wellview Care Jacksonville',
								},
							]
						: location === 'Fort-Pierce'
							? [
									{
										title: 'Understanding PrEP for HIV Prevention | PrEP with Truvada and Descovy | Wellview Care | Fort Pierce',
									},
									{
										name: 'description',
										content:
											"Explore the benefits of Pre-Exposure Prophylaxis (PrEP) for HIV prevention with Truvada and Descovy at Wellview Care in Fort Pierce. Learn how PrEP works, its effectiveness, and the expert guidance you'll receive from our healthcare professionals.",
									},
									{
										name: 'keywords',
										content: 'PrEP, Truvada, Descovy, HIV Prevention, Wellview Care Fort Pierce',
									},
								]
							: [
									{ title: 'Understanding PrEP for HIV Prevention | PrEP with Truvada and Descovy | Wellview Care' },
									{
										name: 'description',
										content:
											"Explore the benefits of Pre-Exposure Prophylaxis (PrEP) for HIV prevention with Truvada and Descovy at Wellview Care in Fort Pierce, Riviera Beach and Fort Lauderdale. Learn how PrEP works, its effectiveness, and the expert guidance you'll receive from our healthcare professionals.",
									},
									{
										name: 'keywords',
										content: 'PrEP, Truvada, Descovy, HIV Prevention, Wellview Care Fort Pierce, Fort Lauderdale, Riviera Beach Healthcare, Florida',
									},
								],
	}),
	component: PepRouteComponent,
})
